import { Grid, TextField, Typography, Box } from '@material-ui/core'
import PropTypes from 'prop-types'
import { Controller, useFormContext } from 'react-hook-form'

import {
  Card,
  CompanyTypeAndSeachInput,
  OrganizationTypeAndSearchInput,
} from 'components'

import constants from 'constants/index'

const GeneralInformationForm = ({ profileType, profile, isEdit }) => {
  const { control, errors } = useFormContext()

  const company = profile?.company
  const organization = profile?.organization
  const defaultProfile = profile?.default
  const profileStatus = profile?.status

  const isNotCollaborator =
    profileType !== constants.user.PROFILE_TYPE_COLLABORATOR

  const isClient = profileType === constants.user.PROFILE_TYPE_CLIENT

  return (
    <Card title="Informações gerais">
      <Grid container spacing={1}>
        <Grid item xs={12}>
          {isEdit &&
          (profile?.originProfileId || !profileStatus || profile?.default) ? (
            <TextField
              label="Nome do Perfil"
              type="text"
              color="primary"
              variant="outlined"
              fullWidth
              defaultValue={profile?.name}
              disabled
            />
          ) : (
            <Controller
              as={
                <TextField
                  label="Nome do Perfil"
                  type="text"
                  color="primary"
                  variant="outlined"
                  error={!!errors.name}
                  helperText={errors?.name?.message}
                  fullWidth
                />
              }
              control={control}
              name="name"
              mode="onBlur"
            />
          )}
        </Grid>
        <Grid item xs={12}>
          {isEdit && !profileStatus ? (
            <TextField
              label="Descrição"
              type="text"
              color="primary"
              variant="outlined"
              fullWidth
              defaultValue={profile?.description}
              disabled
            />
          ) : (
            <Controller
              as={
                <TextField
                  label="Descrição"
                  type="text"
                  color="primary"
                  variant="outlined"
                  error={!!errors.description}
                  helperText={errors?.description?.message}
                  fullWidth
                />
              }
              control={control}
              name="description"
              mode="onBlur"
            />
          )}
        </Grid>
        {isEdit && isNotCollaborator ? (
          <Grid item xs={12}>
            {company && (
              <TextField
                label="Empresa"
                color="primary"
                variant="outlined"
                fullWidth
                defaultValue={company?.name}
                disabled
              />
            )}
            {organization && (
              <TextField
                label="Grupo Advisor"
                color="primary"
                variant="outlined"
                fullWidth
                defaultValue={organization?.name}
                disabled
              />
            )}
          </Grid>
        ) : (
          <>
            {isNotCollaborator && (
              <Grid item xs={12}>
                {isClient ? (
                  <CompanyTypeAndSeachInput control={control} errors={errors} />
                ) : (
                  <OrganizationTypeAndSearchInput />
                )}
              </Grid>
            )}
          </>
        )}
        {defaultProfile && isEdit && (
          <Grid item xs={12}>
            <Box my={1} ml={1}>
              <Typography variant="body2">Perfil sugerido</Typography>
            </Box>
          </Grid>
        )}
      </Grid>
    </Card>
  )
}

GeneralInformationForm.propTypes = {
  errors: PropTypes.object,
  control: PropTypes.object,
  clientProfile: PropTypes.bool,
  setValue: PropTypes.func,
  companies: PropTypes.arrayOf(Object),
  profile: PropTypes.object,
  isEdit: PropTypes.bool,
}

export default GeneralInformationForm
